export default "__VITE_ASSET__BCmz3QGC__"